import { useState } from "react";
import * as Icons from "lucide-react";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { Controller, useFormContext } from "react-hook-form";
import { FilterState } from "../(context)/filter";
import { useFormReset } from "@/hooks/use-form-reset";

type Props = {
  onSearch?: () => void;
}

export const NewSearchFilter = ({
  onSearch
}:Props) => {
  const form = useFormContext<FilterState>()
  const reset = useFormReset(form);
  const [open, setopen] = useState(false);

  return (
    <AlertDialog open={open} onOpenChange={setopen}>
      <AlertDialogTrigger asChild>
        <Button variant="bright" shape="pill" size="2xl">
          <Icons.Search className="w-4 h-4" />
          Nieuwe zoekfilter
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-h-[95dvh] overflow-auto flex flex-col justify-between p-0 gap-0">
        <AlertDialogHeader className="p-4 flex items-center justify-center border-b relative">
          <AlertDialogTitle>Filters</AlertDialogTitle>
          <button
            onClick={() => {
              setopen(false);
            }}
            className="absolute right-4 top-1/2 -translate-y-1/2"
          >
            <Icons.X className="w-4 h-4" />
          </button>
        </AlertDialogHeader>
        <div className="h-full overflow-auto px-4 space-y-4">
          <Accordion type="multiple" defaultValue={["general-search"]}>
            <GeneralSearch />
          </Accordion>
        </div>
        <div className="flex justify-between w-full p-4 border-t">
          <Button onClick={()=>{reset();}} variant="ghost">Alles wissen</Button>
          <Button onClick={()=>{
            onSearch?.();
            setopen(false);
          }}>Clubs weergeven</Button>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

const GeneralSearch = () => {
  const { control } = useFormContext<FilterState>()

  return (
    <AccordionItem value="general-search" className="border-b">
      <AccordionTrigger>
        <p className="text-base font-medium">Algemeen zoekveld</p>
      </AccordionTrigger>
      <AccordionContent>
        <Controller 
          control={control}
          name="search"
          render={({ field }) => (
            <Input 
              {...field} 
              shape="pill" 
              className="h-10"
              placeholder="Zoek naar clubs, ID's..."
              startContent={<Icons.Search className="w-4 h-4" />}
            />
          )}
        />
      </AccordionContent>
    </AccordionItem>
  )
}